import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('FavorittRessurs');

export class FavorittRessurs extends BasisRessurs<l.FavorittModell> {

    static regNavn = "FavorittRessurs";

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            FavorittRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService,
                ressursFeilhåndtering: RessursFeilhåndtering,
                gettextCatalog: gettextCatalog) {
        super("favoritt",
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                brukers: {method: 'GET', url: "/api/favoritt/brukers", params: {}, isArray: true},
                markerSomFavoritt: {
                    method: 'PUT',
                    url: "/api/favoritt/:type/:id",
                    params: {type: "@type", id: "@id"},
                    isArray: true
                },
                slettSomFavoritt: {
                    method: 'DELETE',
                    url: "/api/favoritt/:type/:id",
                    params: {type: "@type", id: "@id"},
                    isArray: true
                }
            });
    }

    //offentlige metoder

    brukers(): ng.resource.IResourceArray<l.FavorittModell> {
        debug("brukers");
        return this.ressurs["brukers"](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke laste brukers favoritter"))
        );
    }

    markerSomFavoritt(type:l.FavorittType, id: string):ng.resource.IResourceArray<l.TynnFavorittModell>{
        debug("markerSomFavoritt", type, id);
        return this.ressurs["markerSomFavoritt"](
            {type: type, id: id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke markere entitet som favoritt"))
        );
    }

    slettSomFavoritt(type:l.FavorittType, id: string):ng.resource.IResourceArray<l.TynnFavorittModell>{
        debug("slettSomFavoritt", type, id);
        return this.ressurs["slettSomFavoritt"](
            {type: type, id: id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke fjerne entitet som favoritt"))
        );
    }

    //statiske hjelpemetoder

}

